// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-module--container--3jyK_","copyright":"footer-module--copyright--1-FxK","socials":"footer-module--socials--CNyCP","link":"footer-module--link--ylud_"};